
const ContactSection = () => {
  const contactInfo = [
    {
      icon: 'ri-mail-line',
      label: 'Email',
      value: 'contact@agglomeration-solution.fr',
      link: 'mailto:contact@agglomeration-solution.fr',
    },
    {
      icon: 'ri-phone-line',
      label: 'Téléphone',
      value: '+33 (0)1 XX XX XX XX',
      link: 'tel:+33100000000',
    },
    {
      icon: 'ri-map-pin-line',
      label: 'Adresse',
      value: 'Adresse à compléter',
      link: null,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary-dark mb-4">
            Contactez-nous
          </h2>
          <p className="text-lg text-gray-dark max-w-2xl mx-auto">
            Une question ? Un projet ? N'hésitez pas à nous contacter
          </p>
        </div>

        <div className="max-w-[1000px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {contactInfo.map((info, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-gray-light rounded-full mx-auto mb-4">
                  <i className={`${info.icon} text-3xl text-primary`}></i>
                </div>
                <div className="text-sm text-gray-dark uppercase tracking-wider mb-2">
                  {info.label}
                </div>
                {info.link ? (
                  <a
                    href={info.link}
                    className="text-xl font-bold text-primary-dark hover:text-primary transition-colors cursor-pointer"
                  >
                    {info.value}
                  </a>
                ) : (
                  <div className="text-xl font-bold text-primary-dark">
                    {info.value}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="rounded-2xl overflow-hidden shadow-xl h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.94722687634!2d2.277019!3d48.8588897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b005%3A0x40b82c3688c9460!2sParis%2C%20France!5e0!3m2!1sfr!2sfr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation Agglomération Solution"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
